// extracted by mini-css-extract-plugin
export default {"facts__highlight":"HFem_YU","facts__subline":"cXrBrN1"};